import React from 'react';
import './ElectionCard.scss';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as CalendarIcon } from 'assets/icons/mingcute_calendar-fill.svg';
import { ReactComponent as ArrowIcon } from 'assets/icons/redesign/arrow-right-up.svg';
import { candidatesCaption, formatSchedule } from 'js/season';
import { facultyGradientByName } from 'theme/faculties';
import AvatarGroup from 'components/redesign/AvatarGroup';

export interface ElectionCardData {
    id: number;
    title: string;
    facultyNames: (string | undefined)[];
    dateStart?: string;
    dateEnd?: string;
    candidatesCount: number;
    pictures: string[];
}
function ElectionCard({
    data,
    embedded,
}: {
    data: ElectionCardData;
    embedded?: boolean;
}): React.ReactElement {
    const { search } = useLocation();
    const { title } = data;
    const background = facultyGradientByName(...data.facultyNames);
    const start = data.dateStart ? new Date(data.dateStart) : undefined;
    const end = data.dateEnd ? new Date(data.dateEnd) : undefined;
    const className = ['rd-card', start && end ? 'rd-card--scheduled' : '']
        .filter(Boolean)
        .join(' ');
    return (
        <Link
            className={className}
            to={`/elections/${data.id}${search}`}
            style={embedded ? undefined : { background }}
            aria-label={`${title}: ${data.candidatesCount} ${candidatesCaption(
                data.candidatesCount
            )}`}
        >
            <span className="rd-card__top">
                <span className="rd-card__title">{title}</span>
                <span className="rd-card__arrow">
                    <ArrowIcon />
                </span>
            </span>

            <span className="rd-card__bottom">
                {start && end && (
                    <time
                        className="rd-card__schedule"
                        dateTime={data.dateStart}
                    >
                        <CalendarIcon aria-hidden="true" />
                        <span>{formatSchedule(start, end)}</span>
                    </time>
                )}
                {embedded ? (
                    <span className="rd-btn rd-btn--dark">Открыть выборы</span>
                ) : (
                    <AvatarGroup pictures={data.pictures} />
                )}
            </span>
        </Link>
    );
}

ElectionCard.defaultProps = { embedded: false };

export default React.memo(ElectionCard);
